/**
 * Featured Collection — Slider with arrow controls + mouse-drag scrolling
 * Mirrors category-showcase pattern.
 */

(function () {
  'use strict';

  function initSlider(track) {
    const section = track.closest('.featured-collection');
    if (!section) return;

    const prevBtn = section.querySelector('.featured-collection__arrow--prev');
    const nextBtn = section.querySelector('.featured-collection__arrow--next');
    if (!prevBtn || !nextBtn) return;

    /** Scroll step = one card width + gap */
    function scrollStep() {
      const card = track.querySelector('.product-card');
      if (!card) return 280;
      const gap = parseFloat(getComputedStyle(track).gap) || 16;
      return card.offsetWidth + gap;
    }

    /** Update disabled state of arrows */
    function updateArrows() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      const atStart = track.scrollLeft <= 2;
      const atEnd = maxScroll <= 0 || track.scrollLeft >= maxScroll - 2;

      prevBtn.classList.toggle('is-disabled', atStart);
      nextBtn.classList.toggle('is-disabled', atEnd);

      prevBtn.setAttribute('aria-disabled', String(atStart));
      nextBtn.setAttribute('aria-disabled', String(atEnd));
    }

    prevBtn.addEventListener('click', function () {
      if (prevBtn.classList.contains('is-disabled')) return;
      track.scrollBy({ left: -scrollStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      if (nextBtn.classList.contains('is-disabled')) return;
      track.scrollBy({ left: scrollStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows, { passive: true });

    // ── Mouse-drag scrolling on desktop ──
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;
    let hasMoved = false;

    track.addEventListener('mousedown', function (e) {
      // Only left button, ignore drags on links/buttons inside cards
      if (e.button !== 0) return;
      isDown = true;
      hasMoved = false;
      startX = e.pageX;
      startScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
    });

    track.addEventListener('mouseleave', function () {
      if (isDown) {
        isDown = false;
        track.classList.remove('is-dragging');
      }
    });

    track.addEventListener('mouseup', function () {
      isDown = false;
      track.classList.remove('is-dragging');
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      const dx = e.pageX - startX;
      if (Math.abs(dx) > 4) hasMoved = true;
      track.scrollLeft = startScrollLeft - dx;
    });

    // Prevent click on cards if the user dragged
    track.addEventListener(
      'click',
      function (e) {
        if (hasMoved) {
          e.preventDefault();
          e.stopPropagation();
          hasMoved = false;
        }
      },
      true
    );

    // Recalculate on resize
    let resizeTimer;
    window.addEventListener(
      'resize',
      function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateArrows, 100);
      },
      { passive: true }
    );

    // Initial state
    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('.featured-collection__track').forEach(function (track) {
      if (track.dataset.fcInit) return;
      track.dataset.fcInit = '1';
      initSlider(track);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme Editor: re-init on section load
  document.addEventListener('shopify:section:load', function (e) {
    const track = e.target.querySelector('.featured-collection__track');
    if (!track) return;
    delete track.dataset.fcInit;
    initSlider(track);
  });
})();
